import React, { useMemo, useState, useEffect } from 'react'
import { Wrapper, BarStrip, ProgressBar, ModalComponent, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setQAAModal, setAssuranceModal } from '../_slices/AppSlice'
// import { computeApplicationProgress } from '../_utils'
// import { useDispatch, useSelector } from 'react-redux'
// import { setAuditModal } from '../_slices/AppSlice'

// const ActionField = ( record ) => {
//     return (
//       <div onClick={async () => {
//         await localStorage.setItem( "link", "display" )
//         await localStorage.setItem( "applicationId", record.value )
//         return window.location.reload()
//       } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
//         {`View`}
//       </div>
//     )
// }

const ProgressField = record => {
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

const ActionField = record => {
  const dispatch = useDispatch()

  const handleClick = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "display")
    window.location.reload()
  }

  

  if( localStorage.getItem( "role" ) === "QA1" ) {
    return (
      ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level1_action === null ) && 
      (<div onClick={() => handleClick( record.value )}  className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`Send to QA1`}
      </div> )
    )
    // return (
    //   ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level1_action === null ) && 
    //     ( <div onClick={async () => {
    //     let payload = JSON.stringify( record.row.original )
    //     await localStorage.setItem( "QAAPayload", payload )
    //     await dispatch( setAssuranceModal( { 
    //       assuranceFlag: true, 
    //         title: "Actions" 
    //     } ) )
    //   } } className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
    //     {`Send to QA1`}
    //   </div> )
    // )
  }

  if( localStorage.getItem( "role" ) === "QA2" ) {
    // return (
    //   ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level2_action === null ) && 
    //     ( <div onClick={async () => {
    //     let payload = JSON.stringify( record.row.original )
    //     await localStorage.setItem( "QAAPayload", payload )
    //     await dispatch( setAssuranceModal( { 
    //       assuranceFlag: true, 
    //         title: "Actions" 
    //     } ) )
    //   } } className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
    //     {`Send to QA3`}
    //   </div> )
    // )
    return (
      ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level2_action === null ) && 
      (<div onClick={() => handleClick( record.value )}  className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`Send to QA3`}
      </div> )
    )
  }

  if( localStorage.getItem( "role" ) === "QA3" ) {
    // return (
    //   ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level3_action === null ) && 
    //     ( <div onClick={async () => {
    //     let payload = JSON.stringify( record.row.original )
    //     await localStorage.setItem( "QAAPayload", payload )
    //     await dispatch( setAssuranceModal( { 
    //       assuranceFlag: true, 
    //         title: "Actions" 
    //     } ) )
    //   } } className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
    //     {`Send to AA`}
    //   </div> )
    // )
    return (
      ( parseInt( record.row.original?.stage ) === 3 && record.row.original?.qa_level3_action === null ) && 
      (<div onClick={() => handleClick( record.value )}  className="cursor-pointer w-auto py-1 px-2 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`Send to AA`}
      </div> )
    )
  }
 
}

const steps = [ "Pending", "Actioned" ]

export default function AllQAA( { product } ) {
  const QAAColumms = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
    // {
    //     Header: "Application Progress",
    //     accessor: "progress",
    //     Cell: ProgressField
    //   },
    {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
    }
   
  ] )
  const dispatch = useDispatch()
  const state = useSelector( state => { 
    return {
      assuranceFlag: state.application.assuranceModal?.assuranceFlag,
      title: state.application.assuranceModal?.title,
    }
  })
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            qa_level1_stage: result.qa_level1_stage,
            qa_level1_action: result.qa_level1_action,
            qa_level1_comments: result.qa_level1_comments,
            qa_level2_stage: result.qa_level2_stage,
            qa_level2_action: result.qa_level2_action,
            qa_level2_comments: result.qa_level2_comments,
            qa_level3_stage: result.qa_level3_stage,
            qa_level3_action: result.qa_level3_action,
            qa_level3_comments: result.qa_level3_comments,
            id: result.id
        }
       } ).filter( record => parseInt( record.stage ) === 3 )
       .filter( val => {
        if( localStorage.getItem( "role" ) === "QA1" ) {
          return val.qa_level1_action === null;
        }

        if( localStorage.getItem( "role" ) === "QA2" ) {
          return val.qa_level2_stage === null
        }

        if( localStorage.getItem( "role" ) === "QA3" ) {
          return val.qa_level3_stage === null
        }
       } )

       //update the state
       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleQAA = async () => {
    let payload = JSON.parse( localStorage.getItem( "QAAPayload" ))

    //schedule a meeting
    // if(  payload?.scheduled_action === "" ) {
      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: payload.id,
          qa_level1_action: localStorage.getItem( "role" ) === "QA1" && "Approved",
          qa_level1_comments: localStorage.getItem( "role" ) === "QA1" && "Test",
          qa_level1_stage: localStorage.getItem( "role" ) === "QA1" && 1,

          qa_level2_action: localStorage.getItem( "role" ) === "QA2" && "Approved",
          qa_level2_comments: localStorage.getItem( "role" ) === "QA2" && "Test",
          qa_level2_stage: localStorage.getItem( "role" ) === "QA2" && 2,

          qa_level3_action: localStorage.getItem( "role" ) === "QA3" && "Approved",
          qa_level3_comments: localStorage.getItem( "role" ) === "QA3" && "Test",
          qa_level3_stage: localStorage.getItem( "role" ) === "QA3" && 3,

          progress: localStorage.getItem( "role" ) === "QA3" && parseInt( payload.progress ) + 20,
          stage: localStorage.getItem( "role" ) === "QA3" && parseInt( payload.stage ) + 1
          // task: "Schedule_Audit",
          // comment: "Audit has been scheduled",
          // created_by: localStorage.getItem( "email" ),
          // email_address: state.email
        } )
        if( response.data ) {
          dispatch( setAssuranceModal( { assuranceFlag: false, title: "" } ) )
          alert( response.data.message )
          return window.location.reload()
        }
      } catch (error) {}
    // }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Quality Assurance Authority List Under Process of IT Service Provider`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
              <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={QAAColumms}
                data={records}
              />
            </div>
          </div>
        </div>
        <ModalComponent title={state.title} open={state.assuranceFlag} handleOpen={() => dispatch( setAssuranceModal( { assuranceFlag: false, title: "" } ) )}>
          {/* <div className="cursor-pointer" >Close</div> */}
          <div className="grid grid-cols-1 w-[700px]">
            
            {`Send to the next level in QA`}
            
            <div className="flex items-center">
              <button onClick={() => dispatch( setAssuranceModal( { assuranceFlag: false, title: "" } ) )} className="bg-blue-700 w-20 text-white text-xs my-2 px-2 py-1 mx-2" type="button">
                {`Cancel`}
              </button>
              <button onClick={handleQAA} className="bg-green-700 w-20 text-white text-xs my-2 px-2 py-1" type="button">
                {`Submit`}
              </button>
            </div>
          </div>
        </ModalComponent>
    </Wrapper>
  )
}
